module.exports = __webpack_public_path__ + "teqbahn-assets/media/8.e59dbbbd.jpg";